/* Запуск прототипа внутри React: скрипты подключаются классическими тегами строго по порядку app.html.
   На месте «@модуль» вызывается установщик React-модуля (src/bridge/modules.ts): он выставляет в window объект с тем же контрактом.
   Последний шаг — @shell: каркас (src/features/shell) запускается, когда разметка <body> уже стоит в документе. */
import { assetInline, scripts } from 'virtual:legacy';
import { installModule } from './modules';

let booted: Promise<void> | null = null;

function addScript(src: string): Promise<void> {
  return new Promise((ok, fail) => {
    const s = document.createElement('script');
    s.src = src;
    s.async = false;
    s.dataset.legacy = '1';
    s.onload = () => ok();
    s.onerror = () => fail(new Error('не загрузился ' + src));
    document.body.appendChild(s);
  });
}

/** Подключить прототип один раз за жизнь страницы (StrictMode вызывает эффекты дважды) */
export function bootLegacy(beforeShell?: () => Promise<void>): Promise<void> {
  if (booted) return booted;
  booted = (async () => {
    /* до boot.js: картинки вшиты, и он переводит их в blob:, как собранный прототип */
    const host = window as unknown as { __ASSETS?: Record<string, string> };
    if (!host.__ASSETS) host.__ASSETS = assetInline;
    /* группа скриптов между «@модулями» ставится разом: async=false сохраняет порядок исполнения, загрузка идёт параллельно */
    let group: Promise<void>[] = [];
    for (const s of scripts) {
      if (s.startsWith('@')) {
        await Promise.all(group);
        group = [];
        if (s === '@shell') await beforeShell?.();
        installModule(s.slice(1));
      } else group.push(addScript(s));
    }
    await Promise.all(group);
  })();
  return booted;
}
